<template>
  <div class="animated fadeIn">
    <b-container fluid class="pt-3 pr-3 pb-0 pl-3">
      <b-row>
        <b-col>
          <!-- Cancellations -->
          <b-card class="border-0">
            <div class="card-text pb-0">
              <div class="d-flex flex-row justify-content-start">
                <div class="text-dark mr-3"><i class="el-icon-circle-plus headericon"></i></div>
                <div class="h4 font-weight-bold text-dark">Tilføj projekt</div>
              </div>
            </div>
          </b-card>
          <b-card class="border-0">
            <b-row>
            <b-col lg="6" md="6" sm="12">
            <div class="card-text pb-0">
              <div class="h6 open-sans line-height-golden py-2">
                Her kan du registrere navn og kontaktoplysninger på de håndværkere, som har udført projekterne. Efter du har registreret håndværkerne, sætter vi straks gang i processen med at kontakte håndværker og bygherre mm.
              </div>
              <b-btn variant="success" @click="buyProjects" class="border-0 rounded">
                <i class="el-icon-bank-card mr-1"></i>
                Køb flere projekter
              </b-btn>
              <div class="py-2"></div>
              <loading :show="show" :label="label" :overlay="overlay"></loading>
              <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
            </div>
            </b-col>
            <b-col lg="6" md="6" sm="12">
              <b-card no-body class="border-0">
                <b-list-group>
                  <b-list-group-item class="border-0">
                    <p class="w-50 d-inline-block float-left m-0 p-0">Du har købt</p>
                    <p class="w-50 d-inline-block float-right text-right m-0 p-0">
                      <span class="bg-info pt-1 pb-1 pr-2 pl-2 rounded mr-1">{{ projects }}</span>
                      projekter
                    </p>
                  </b-list-group-item>
                  <b-list-group-item class="border-0">
                    <p class="w-50 d-inline-block float-left m-0 p-0">Du har aktiveret</p>
                    <p class="w-50 d-inline-block float-right text-right m-0 p-0">
                      <span class="bg-success pt-1 pb-1 pr-2 pl-2 rounded mr-1">{{ projects_create }}</span>
                      projekter
                    </p>
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <b-row>
        <b-col>
          <projectlist :projects="projects" :projects_create="projects_create" @UpdateProject="UpdateProject"></projectlist>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
import projectlist from './producenter/ProducenterAddProject'
export default {
  components: {
    projectlist,
    loading,
    Simplert
  },
  data () {
    return {
      show: false,
      label: 'Loading...',
      projects: 0,
      projects_create: 0,
      overlay: true
    }
  },
  methods: {
    buyProjects () {
      this.$router.push('/koeb-projekter')
    },
    UpdateProject (projects, projectsCreate) {
      this.projects = projects
      this.projects_create = projectsCreate
    }
  }
}
</script>
<style scoped>
.main .container-fluid {
  padding: 15px 0;
}
</style>


// WEBPACK FOOTER //
// AddProjects.vue?5f28c2fc